"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converters = void 0;
exports.converters = {
    '1.0.0': from__undefined__to__1_0_0,
    '1.1.0': from__1_0_0__to__1_1_0,
    '1.2.0': from__1_1_0__to__1_2_0,
};
function from__undefined__to__1_0_0(asyncapi, _) {
    asyncapi.asyncapi = '1.0.0';
    return asyncapi;
}
function from__1_0_0__to__1_1_0(asyncapi, _) {
    asyncapi.asyncapi = '1.1.0';
    return asyncapi;
}
function from__1_1_0__to__1_2_0(asyncapi, _) {
    asyncapi.asyncapi = '1.2.0';
    return asyncapi;
}
